import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import permission from "./directives/permission";

import "./styles/index.scss";

Vue.use(ElementUI, { size: "small" });
Vue.directive("permission", permission);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
